<template>
  <div class="content">
    <el-row>
      <el-col :span="5">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_msptitle1.png')" class="titleimg" />
      </el-col>
    </el-row>
    <p class="twotitle">专为学生而阅</p>
    <el-row class="one">
      <img v-lazy="require('../../assets/imgs/iphone_msp1.png')" class="iphoneimg" />
    </el-row>
    <el-row>
      <el-col :span="5">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_msptitle2.png')" class="titleimg" />
      </el-col>
    </el-row>
    <el-row class="two">
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/iphone_msp2.png')" class="iphoneimg" />
      </el-col>
    </el-row>
    <el-row class="three">
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/iphone_msp3.png')" class="iphoneimg" />
      </el-col>
    </el-row>
    <!-- <el-row>
      <el-col :span="5">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_msptitle3.png')" class="titleimg" />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20"><img v-lazy="require('../../assets/imgs/iphone_msp4.png')" class="iphoneimg" /></el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row> -->
    <el-row>
      <el-col :span="5">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_msptitle4.png')" class="titleimg" />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="22">
        <el-table stripe id="table" style="width: 100%" :data="tableData">
          <el-table-column prop="name" label="标题" style="width:50%">
          </el-table-column>
          <el-table-column prop="data" label="规格" style="width:50%">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-col :span="5">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_msptitle5.png')" class="titleimg" />
      </el-col>
    </el-row>
    <p class="twotitle">实现“随借、随还、随充”</p>
    <p class="twotitle">让用户随时随地阅读书籍</p>
    <el-row class="four">
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/iphone_msp5.png')" class="iphoneimg">
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="5">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_msptitle3.png')" class="titleimg" />
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <img v-lazy="require('../../assets/imgs/iphone_mspjhg2.png')" class="msp_detailimg" />
      </el-col>
    </el-row>
    <!-- <el-row>
      <el-col :span="5">&nbsp;</el-col>
      <el-col :span="14">
        <img v-lazy="require('../../assets/imgs/iphone_msp_title2.png')" class="msp_titleimg" />
        <img v-lazy="require('../../assets/imgs/iphone_msp_back3.png')" class="mspback mspback2" />
        <el-carousel trigger="click" :loop="true" height="40vh" class="msp_siwper" indicator-position="outside">
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/iphone_mspjhg1.png')" class="msp_detailimg" />
          </el-carousel-item>
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/iphone_mspjhg1.png')" class="msp_detailimg" />
          </el-carousel-item>
        </el-carousel>
      </el-col>
      <el-col :span="5">&nbsp;</el-col>
    </el-row> -->
    <el-row>
      <el-col :span="5">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_msptitle7.png')" class="titleimg" />
      </el-col>
    </el-row>
    <el-row>
      <p style="color:#999999;text-aligin:center;margin-bottom:3vh">
        行知墨水屏，予您优越的阅读体验。
      </p>
    </el-row>
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20">
        <el-carousel trigger="click" :loop="true" height="20vh" indicator-position="outside">
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/Reading_room2.png')" class="iphoneimg" />
          </el-carousel-item>
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/The_classroom.png')" class="iphoneimg" />
          </el-carousel-item>
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/The_library1.png')" class="iphoneimg" />
          </el-carousel-item>
        </el-carousel>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "iphoneMsp",
  data () {
    return {
      tableData: [
        { name: "操作系统：", data: "Android 8.1" },
        { name: "产品尺寸：", data: "7.8寸/10.3寸" },
        { name: "分辨率：", data: "1404x1872" },
        { name: "触控类型：", data: "电容触控" },
        { name: "数据接口：", data: "Type-C" },
        { name: "无线连接：", data: "WIFI(5G/2.4G)、蓝牙" },
        { name: "固件升级：", data: "支持本地升级/OTA升级" },
        { name: "操作温度：", data: "0°C- 50°C" },
        { name: "语言：", data: "支持多国语言" },
        { name: "处理器：", data: "Quad-core 1.6G Hz/PX30" },
        { name: "刷新模式：", data: "A2快刷、局刷、全刷可选" }
      ]
    };
  }
};
</script>
<style scoped>
.title {
  margin-top: 5vh;
  margin-bottom: 4vh;
  height: 2.5vh;
  width: auto;
}
.iphoneimg {
  width: 100%;
  height: 100%;
}
.iphoneimgbig {
  width: 40vw;
  height: 2.7vh;
}
.twotitle {
  color: rgb(153, 153, 153);
  margin-bottom: 1vh;
}
.one {
  margin-top: 5vh;
}
.one p {
  font-size: 13px;
  color: rgb(153, 153, 153);
  text-align: left;
  padding: 2vw 0vw;
  text-indent: 1rem;
}
.one .rightimg {
  position: relative;
  top: 2vh;
  height: 20vh;
  width: 40vw;
  right: -2vw;
}
.two .leftimg {
  position: relative;
  top: 2vh;
  height: 35vh;
  width: 60vw;
  left: -13.5vw;
}
.two_right,
.three_right,
.four_right {
  position: relative;
  top: 3.5vh;
  padding: 1vh;
  background-image: url("../../assets/imgs/iphone_msp_back1.png");
}
.two .rightimg,
.three .leftimg {
  height: 4vh;
  width: 30vw;
  margin-top: 1.5vh;
  margin-bottom: 1.5vh;
}
.three_right {
  left: 0;
}
.three .rightimg {
  position: relative;
  top: 2vh;
  height: 35vh;
  width: 60vw;
}
.four_right {
  padding-left: 5vw;
  margin-left: 1vw;
  top: 1.5vh;
  left: 0;
  font-size: 13px;
}
.four {
  text-align: left;
  margin-top: 5vh;
}
.four .detail {
  color: rgb(153, 153, 153);
}
.four .rightimg {
  position: relative;
  height: 5vh;
  margin-bottom: 1vh;
  width: 30vw;
}
.four .rightimg:last-of-type {
  width: 100%;
  height: 5.5vh;
}
.msp_titleimg {
  position: absolute;
  z-index: 999;
  left: 10vw;
  height: 22px;
  top: -2vh;
}
.mspback {
  position: absolute;
  left: 0;
  top: 2vh;
  width: 85%;
}
.mspback2 {
  left: 15vw;
  top: 7vh;
}
.msp_siwper {
  position: relative;
  z-index: 999;
  height: 44vh;
  margin-top: 5vh;
  margin-bottom: 5vh;
}
.titleimg {
  width: auto;
  height: 100%;
}
.msp_detailimg {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/iphone/msp.vue